// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as LumiResult from "lumi-rescript/lib/es6/src/LumiResult.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Stdlib_String from "@rescript/runtime/lib/es6/Stdlib_String.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function jsonCodec(valueCodec) {
  return Jzon.object2(param => [
    param.start,
    param.end
  ], param => ({
    TAG: "Ok",
    _0: {
      start: param[0],
      end: param[1]
    }
  }), Jzon.field("start", valueCodec), Jzon.field("end", valueCodec));
}

let Range = {
  jsonCodec: jsonCodec
};

let options = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];

let jsonCodec$1 = LumiJzon.anySumAsString(options, prim => prim.toLowerCase());

let DayOfWeek = {
  options: options,
  jsonCodec: jsonCodec$1
};

function secondsToString(seconds, maxPrecision) {
  let trailing = /\.?0+$/;
  let str = seconds.toFixed(maxPrecision);
  let match = Stdlib_String.indexOfOpt(str, ".");
  return (
    match === 1 ? "0" + str : str
  ).replace(trailing, "");
}

function toString(param) {
  let hourS = param.hour.toString().padStart(2, "0");
  let minS = param.min.toString().padStart(2, "0");
  let secS = secondsToString(param.sec, 3);
  let secSuffix = secS === "00" ? "" : ":" + secS;
  return hourS + `:` + minS + secSuffix;
}

let regexp = /^(\d{2}):(\d{2})(?::(\d+(?:\.\d+)?))?$/;

function fromString(s) {
  let result = regexp.exec(s);
  if (result == null) {
    return {
      TAG: "Error",
      _0: "invalid format"
    };
  }
  let m = result.slice(1);
  let hour = LumiOption.okOr(Stdlib_Option.flatMap(m[0], s => Stdlib_Int.fromString(s, 10)), "invalid hours part");
  let min = LumiOption.okOr(Stdlib_Option.flatMap(m[1], s => Stdlib_Int.fromString(s, 10)), "invalid minutes part");
  let secS = m[2];
  let sec = secS !== undefined ? LumiOption.okOr(Stdlib_Option.flatMap(Primitive_option.valFromOption(secS), Stdlib_Float.fromString), "invalid seconds part") : ({
      TAG: "Ok",
      _0: 0
    });
  return Stdlib_Result.map(LumiResult.sequence3([
    hour,
    min,
    sec
  ]), param => ({
    hour: param[0],
    min: param[1],
    sec: param[2]
  }));
}

function stringCodec_fromString(s) {
  return LumiResult.ok(fromString(s));
}

let stringCodec = {
  toString: toString,
  fromString: stringCodec_fromString
};

let jsonCodec$2 = LumiJzon.stringCodec(stringCodec);

let TimeOfDay = {
  toString: toString,
  regexp: regexp,
  fromString: fromString,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec$2
};

let jsonCodec$3 = Jzon.object2(param => [
  param.day,
  param.time
], param => ({
  TAG: "Ok",
  _0: {
    day: param[0],
    time: param[1]
  }
}), Jzon.field("day", jsonCodec$1), Jzon.field("time", jsonCodec$2));

let TimeOfWeek = {
  jsonCodec: jsonCodec$3
};

function fromDate(d) {
  return {
    year: d.getFullYear(),
    month: d.getMonth() + 1 | 0,
    day: d.getDate(),
    hour: d.getHours(),
    minute: d.getMinutes(),
    second: d.getSeconds() + d.getMilliseconds() / 1000
  };
}

let jsonCodec$4 = Jzon.custom(v => {
  let year = v.year.toString().padStart(4, "0");
  let month = v.month.toString().padStart(2, "0");
  let day = v.day.toString().padStart(2, "0");
  let hour = v.hour.toString().padStart(2, "0");
  let minute = v.minute.toString().padStart(2, "0");
  let second = secondsToString(v.second, 3);
  return Jzon.encodeWith(year + `-` + month + `-` + day + `T` + hour + `:` + minute + `:` + second, Jzon.string);
}, json => Stdlib_Result.flatMap(Jzon.decodeWith(json, Jzon.string), s => ({
  TAG: "Ok",
  _0: fromDate(new Date(s))
})));

let LocalTime = {
  fromDate: fromDate,
  jsonCodec: jsonCodec$4
};

let jsonCodec$5 = LumiJzon.taggedVariant(value => {
  switch (value.TAG) {
    case "AbsolutePeriodDef" :
      return [
        "AbsolutePeriodDef",
        Jzon.encodeWith(value._0, jsonCodec(jsonCodec$4))
      ];
    case "WeeklyPeriodDef" :
      return [
        "WeeklyPeriodDef",
        Jzon.encodeWith(value._0, jsonCodec(jsonCodec$3))
      ];
    case "DailyPeriodDef" :
      return [
        "DailyPeriodDef",
        Jzon.encodeWith(value._0, jsonCodec(jsonCodec$2))
      ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "AbsolutePeriodDef" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec(jsonCodec$4)), absolutePeriod => ({
        TAG: "AbsolutePeriodDef",
        _0: absolutePeriod
      }));
    case "DailyPeriodDef" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec(jsonCodec$2)), dailyPeriod => ({
        TAG: "DailyPeriodDef",
        _0: dailyPeriod
      }));
    case "WeeklyPeriodDef" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec(jsonCodec$3)), weeklyPeriod => ({
        TAG: "WeeklyPeriodDef",
        _0: weeklyPeriod
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let PeriodDef = {
  jsonCodec: jsonCodec$5
};

function jsonCodec$6(stateCodec) {
  return Jzon.object2(param => [
    param.state,
    param.def
  ], param => ({
    TAG: "Ok",
    _0: {
      state: param[0],
      def: param[1]
    }
  }), Jzon.field("state", stateCodec), Jzon.field("def", jsonCodec$5));
}

let Period = {
  jsonCodec: jsonCodec$6
};

function jsonCodec$7(timeZoneCodec, stateCodec) {
  return Jzon.object3(param => [
    param.defaultState,
    param.timeZone,
    param.periods
  ], param => ({
    TAG: "Ok",
    _0: {
      defaultState: param[0],
      timeZone: param[1],
      periods: param[2]
    }
  }), Jzon.field("defaultState", stateCodec), Jzon.field("timeZone", timeZoneCodec), Jzon.field("periods", Jzon.array(jsonCodec$6(stateCodec))));
}

let Timeline = {
  jsonCodec: jsonCodec$7
};

export {
  Range,
  DayOfWeek,
  secondsToString,
  TimeOfDay,
  TimeOfWeek,
  LocalTime,
  PeriodDef,
  Period,
  Timeline,
}
/* jsonCodec Not a pure module */
